module.exports = __webpack_public_path__ + "static/media/webchat_icon.7971da43.svg";